var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video-player',{ref:"player",attrs:{"item":_vm.videoItem,"active":true,"popup":false,"taking":false,"testing":false,"options":_vm.clientPlayerOptions},on:{"pause":_vm.pause,"played":_vm.play}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entertain-menu-bar pa-3"},[_c('div',{staticClass:"volume-controls"},[_vm._v("Volume Controls ☝🏽")])])
}]

export { render, staticRenderFns }